import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { forkJoin, Observable } from "rxjs";
import { WebApiService } from "_libs/web-api";
import {
	AddressAutoCompleteOption,
	ManualAddressData,
	StreetType,
	Suburb,
	UnitType,
} from "../models";

@Injectable({
	providedIn: "root",
})
export class AddressService {
	private envConfig = environment;

	constructor(private webApiService: WebApiService) {}

	public suggestion(
		isMule: boolean,
		partialAddress: string,
		isEnergy: boolean
	): Observable<AddressAutoCompleteOption[]> {
		const pAddress = encodeURIComponent(partialAddress.trim());
		const url = isEnergy
			? `address/Suggestion?address=${pAddress}`
			: `addressmgmt/compositeAddress?partialText=${pAddress}`;

		return this.webApiService.get(url, true, undefined, isMule);
	}

	public getFragmentedAddressFromGNAF(
		gnaf: string
	): Observable<any> {
		const url = `address/Address?gnafId=${gnaf}`;
		return this.webApiService.get(url, true, undefined, false);
	}

	public suburbFromPostcode(
		isMule: boolean,
		postcode: string
	): Observable<Suburb[]> {
		const url = isMule
			? "geographicAddressManagement/area?search={postcode}"
			: "address/suburb?postcode={postcode}";
		return this.webApiService.get(
			this.valueReplacer(url, ["postcode"], [postcode]),
			true,
			undefined,
			isMule
		);
	}

	public getManualAddressData(
		isMule: boolean
	): Observable<ManualAddressData> {
		return forkJoin([
			this.unitTypes(isMule),
			this.streetTypes(isMule),
		]) as any;
	}

	protected unitTypes(isMule: boolean): Observable<UnitType[]> {
		const url = isMule
			? "geographicAddressManagement/referenceData?name=subUnitType"
			: "address/buildingtypes";
		return this.webApiService.get(url, true, undefined, isMule);
	}

	protected streetTypes(isMule: boolean): Observable<StreetType[]> {
		const url = isMule
			? "geographicAddressManagement/referenceData?name=streetType"
			: "address/StreetTypes";
		return this.webApiService.get(url, true, undefined, isMule);
	}

	protected getFullUrl(partialUrl: string, drupalEndpoint = false): string {
		let host = this.envConfig.dev.apiHost;
		if (drupalEndpoint) {
			host = this.envConfig.dev.durpalApiHost;
		}
		return `${host}${partialUrl}`;
	}

	protected valueReplacer(
		url: string,
		strs: string[],
		values: string[]
	): string {
		let retVal = url;
		strs.forEach((s, i) => {
			retVal = retVal.replace(`{${s}}`, values[i]);
		});
		return retVal;
	}
}
